import {
    themeStorageKey,
    validateThemeCode,
} from '@uipath/portal-shell-util';

export function initializeThemeCache() {
    const validCachedTheme = validateThemeCode(localStorage.getItem(themeStorageKey));
    if (!validCachedTheme) {
        localStorage.setItem(themeStorageKey, 'autoTheme');
    }
}
